import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { CalendarAltIcon } from "assets/icons";
import cn from "classnames";
import { FormField } from "ui/FormField";

import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import "./DateRangeInputClear.scss";
import { DateRangeInputProps } from "./DateRangeInput.types";

import styles from "./DateRangeInput.module.scss";

const DateRangeInput = ({
  label,
  errorMessage,
  value,
  onChange,
  minDate
}: DateRangeInputProps) => {
  return (
    <FormField label={label} errorMessage={errorMessage}>
      <div className={styles.dateInput__wrapper}>
        <DateRangePicker
          value={value}
          onChange={onChange}
          className={cn(styles.dateInput, {
            [styles.dateInput__error]: !!errorMessage
          })}
          clearIcon={value ? undefined : null}
          format="dd/MM/yyyy"
          locale={"en"}
          minDate={minDate}
          calendarIcon={<CalendarAltIcon color="#FB3973" />}
        />
      </div>
    </FormField>
  );
};

export default DateRangeInput;
